<template>
  <div class="page-wrapper py-4">
    <div id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu />

      <!-- Hero -->
      <div id="page1" bg="black" class="section section-black hero-section">
        <div class="hero-content">
          <h1 class="hero-title fuente-posm">Audio</h1>
          <p class="hero-subtitle fuente-nova">
            Sonido de alta fidelidad que desaparece en el espacio.
          </p>
          <div class="hero-actions">
            <button class="btn-primary fuente-nova2" @click="openContact">Contáctanos</button>
            <button class="btn-secondary fuente-nova2" @click="openProjects">Nuestros Proyectos</button>
          </div>
        </div>
      </div>

      <!-- Feature 1: Diseño integrado -->
      <div id="page2" bg="white" class="section section-white feature-section">
        <div class="feature-content">
          <div class="feature-text">
            <span class="feature-tag fuente-nova2">Diseño</span>
            <h2 class="feature-title fuente-posm">Parlantes que se integran, no que se instalan</h2>
            <p class="feature-body fuente-nova">
              Altavoces integrados, no visibles. Con Sonos, creamos audio arquitectónico,
              inmerso en el diseño, sin cables, solo sonido donde lo necesitas.
              <br><br>
              Disfruta de un sonido diseñado para acompañar cada momento.
            </p>
          </div>
          <div class="feature-badge fuente-posm" style="flex:1; max-width:580px;">
            <img src="@/assets/images/Fotos Web Proactive/sonos.jpg" alt="Sonos" class="sonos-logo" />
          </div>
        </div>
      </div>

      <!-- Feature 2: Control total -->
      <div id="page3" bg="black" class="section section-black feature-section feature-dark">
        <div class="feature-content">
          <div class="feature-text">
            <span class="feature-tag fuente-nova2">Control</span>
            <h2 class="feature-title fuente-posm">Multi-zona desde tu teléfono</h2>
            <p class="feature-body fuente-nova">
              Diferentes zonas, diferentes ambientes, un solo control.
              Desde la terraza hasta el lobby, cada espacio tiene su propio sonido
              sin interferir con los demás.
              <br><br>
              Compatible con Apple HomeKit, Google Assistant y Amazon Alexa.
            </p>
          </div>
          <div class="feature-badge feature-badge-light fuente-posm" style="flex:1; max-width:580px;">
            <img src="@/assets/images/Fotos Web Proactive/audiomultizonasonos.png" alt="Multi-zona Sonos" class="sonos-logo" />
          </div>
        </div>
      </div>

      <!-- Feature 3: Proyectos -->
      <div id="page4" bg="white" class="section section-white proyectos-section">
        <div class="proyectos-content">
          <h2 class="proyectos-title fuente-posm">Instalaciones reales</h2>
          <p class="proyectos-subtitle fuente-nova">
            Proyectos de audio en hoteles, restaurantes y espacios residenciales premium.
          </p>
          <div class="proyectos-grid">
            <div class="proyecto-item fuente-nova2">Brisas Wayam</div>
            <div class="proyecto-item fuente-nova2">Boyance</div>
            <div class="proyecto-item fuente-nova2">Reef Club</div>
            <div class="proyecto-item fuente-nova2">Hacienda Kancabchen</div>
            <div class="proyecto-item fuente-nova2">Boston's Pizza</div>
            <div class="proyecto-item fuente-nova2">Residencias Premium</div>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div id="page5" bg="white" class="section section-white cta-section">
        <h2 class="cta-title fuente-posm">¿Listo para el silencio perfecto?</h2>
        <button class="btn-cta fuente-nova2" @click="openContact">Contáctanos Ahora</button>
        <button class="btn-cta-link fuente-nova2" @click="openProjects">Nuestros Proyectos</button>
      </div>

      <!-- Footer -->
      <FooterProactive id="page6" bg="black" class="section section-black" />
    </div>
  </div>
</template>

<script>
import menutop from '@/components/structure/menutop.vue'
import FooterProactive from '@/components/pages/proactive/FooterProactive.vue'
import { openContactModal, openPricingModal } from '@/utils/modalHelper'

export default {
  name: 'AudioView',
  components: { menutop, FooterProactive },
  data() {
    return {
      menu: 'black',
      currentSection: 1,
    }
  },
  watch: {
    currentSection() {
      const el = document.getElementById(`page${this.currentSection}`)
      if (el) {
        this.menu = el.classList.contains('section-white') ? 'white' : 'black'
      }
    }
  },
  methods: {
    openContact() { openContactModal() },
    openProjects() {
      openPricingModal({
        description: 'Del sureste de México al país entero. Instalaciones de audio que conectan tecnología con espacios que exigen excelencia.',
      })
    },
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop
      const windowHeight = window.innerHeight
      const section = Math.floor((scrollPosition + 80) / windowHeight) + 1
      this.currentSection = Math.max(1, Math.min(section, 6))
    },
  },
}
</script>

<style lang="css">
.page-wrapper {
  background-color: #F0EFEB;
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.master::-webkit-scrollbar {
  display: none !important;
}

@media (max-width: 992px) {
  .master { padding-top: 0px !important; }
}
</style>

<style lang="css" scoped>
.section {
  width: 100vw;
  min-height: 100vh;
  scroll-snap-align: start;
  box-sizing: border-box;
}

.section-black { background-color: #1a1a1a; }
.section-white { background-color: #ffffff; }

/* Hero */
.hero-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 120px 80px;
  background-image: linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.65)),
    url('~@/assets/images/Fotos Web Proactive/audiomultizona.jpg');
  background-size: cover;
  background-position: center;
}

.hero-content { max-width: 700px; }

.hero-title {
  font-size: clamp(72px, 10vw, 140px);
  font-weight: 700;
  color: white;
  margin: 0 0 24px 0;
  line-height: 1;
}

.hero-subtitle {
  font-size: clamp(20px, 2.5vw, 32px);
  color: rgba(255,255,255,0.85);
  margin: 0 0 48px 0;
  line-height: 1.4;
}

.hero-actions {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.btn-primary {
  background-color: white;
  color: #1a1a1a;
  border: none;
  border-radius: 8px;
  padding: 16px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-primary:hover { opacity: 0.88; }

.btn-secondary {
  background-color: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 8px;
  padding: 16px 40px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background-color: white;
  color: #1a1a1a;
}

/* Features */
.feature-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 80px;
}

.feature-dark { background-color: #1a1a1a; }

.feature-content {
  max-width: 1000px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}

.feature-text { flex: 1; max-width: 580px; }

.feature-tag {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-2, #333);
  display: block;
  margin-bottom: 16px;
}

.feature-dark .feature-tag { color: rgba(255,255,255,0.6); }

.feature-title {
  font-size: clamp(36px, 4vw, 60px);
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 24px 0;
  color: #1a1a1a;
}

.feature-dark .feature-title { color: white; }

.feature-body {
  font-size: clamp(16px, 1.8vw, 22px);
  line-height: 1.6;
  color: #555;
  margin: 0;
}

.feature-dark .feature-body { color: rgba(255,255,255,0.75); }

.feature-badge {
  font-size: clamp(48px, 6vw, 88px);
  font-weight: 700;
  color: #f0efeb;
  white-space: nowrap;
  flex-shrink: 0;
}

.feature-badge-light { color: rgba(255,255,255,0.12); }
.sonos-logo { width: 100%; height: auto; display: block; object-fit: contain; }

/* Proyectos */
.proyectos-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px;
}

.proyectos-content {
  max-width: 900px;
  width: 100%;
  text-align: center;
}

.proyectos-title {
  font-size: clamp(40px, 5vw, 72px);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 20px 0;
}

.proyectos-subtitle {
  font-size: clamp(16px, 2vw, 22px);
  color: #777;
  margin: 0 0 48px 0;
}

.proyectos-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}

.proyecto-item {
  background-color: #f5f5f3;
  border-radius: 12px;
  padding: 16px 28px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* CTA */
.cta-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  gap: 32px;
}

.cta-title {
  font-size: clamp(36px, 5vw, 70px);
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0;
}

.btn-cta {
  background-color: #1a1a1a;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 16px 48px;
  font-size: 18px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-cta:hover { opacity: 0.85; }

.btn-cta-link {
  background: transparent;
  border: none;
  color: #1a1a1a;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
  transition: opacity 0.3s ease;
}

.btn-cta-link:hover { opacity: 0.6; }

/* Mobile */
@media (max-width: 768px) {
  .hero-section { padding: 100px 24px 60px; }
  .feature-section { padding: 60px 24px; }
  .feature-content { flex-direction: column; gap: 32px; }
  .feature-badge { display: none; }
  .proyectos-section { padding: 60px 24px; }
  .cta-section { padding: 60px 24px; }
  .hero-actions { flex-direction: column; }
  .btn-primary, .btn-secondary { width: 100%; text-align: center; }
}
</style>
